var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTeen = function SvgTeen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    fill: "none",
    viewBox: "0 0 16 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8 11c3 0 6.36 1.95 6.65 2.63.24.55.35 2.24.35 2.24 0 .63-.47 1.13-1.05 1.13H2.05C1.47 17 1 16.5 1 15.87c0 0 .11-1.7.35-2.24C1.64 12.95 5 11 8 11ZM8 7.15A3.08 3.08 0 1 1 8 1a3.08 3.08 0 0 1 0 6.15Z",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M6 3h7",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgTeen;